import ApiService from './api.service';
import type { ListRecordsResponse, SingleRecordResponse } from './pipelineNode.service';

export type { ListRecordsResponse };

export interface Dimension {
  id: string;
  name: string;
  column_name: string;
  pipeline_node_id: string;
  field_id: string;
  description: string;
  formatter?: string;
  taxonomic_id?: string;
  managed_by_template_id?: string;
  include_in_supersets?: boolean;
  created_at?: string;
  updated_at?: string;
}

export class DimensionService {
  async find(options?: {
    page?: number;
    pageSize?: number;
    filters?: Record<string, any>;
  }): Promise<ListRecordsResponse<Dimension>> {
    const {
      page = 1,
      pageSize = 50,
      filters = {},
    } = options || {};

    const queryParams: Record<string, any> = {
      page,
      limit: pageSize,
      ...filters,
    };

    const result = await ApiService.getInstance().request(
      'GET',
      '/dimensions',
      queryParams
    ) as ListRecordsResponse<Dimension>;

    return result;
  }

  async findById(id: string): Promise<Dimension> {
    const result = await ApiService.getInstance().request(
      'GET',
      `/dimensions/${id}`
    ) as SingleRecordResponse<Dimension>;
    return result.record;
  }

  async save(dimension: Partial<Dimension>): Promise<Dimension> {
    const result = await ApiService.getInstance().request(
      'PATCH',
      `/dimensions/${dimension.id}`,
      dimension
    ) as SingleRecordResponse<Dimension>;
    return result.record;
  }

  async create(dimension: Partial<Dimension>): Promise<Dimension> {
    const result = await ApiService.getInstance().request(
      'POST',
      '/dimensions',
      dimension
    ) as SingleRecordResponse<Dimension>;
    return result.record;
  }

  async delete(id: string): Promise<void> {
    await ApiService.getInstance().request(
      'DELETE',
      `/dimensions/${id}`
    );
  }
}

export const dimensionService = new DimensionService();
